jQuery(document).ready(function() {
    /*************************/
    /******* Général *********/
    /*************************/

    var loadingDiv = jQuery('.showmore');
    var loading = jQuery('.showmore .loading');
    var btnPlus = jQuery('.showmore .btnplus');

    $(function(){
        $(".drawer--left").drawer({
            class: {
                nav: 'drawer-nav--left',
                toggle: 'drawer-toggle--left',
                overlay: 'drawer-overlay',
                open: 'drawer-open',
                close: 'drawer-close',
                dropdown: 'drawer-dropdown'
            }
        });
        $(".drawer--top").drawer({
            class: {
                nav: 'drawer-nav--top',
                toggle: 'drawer-toggle--top',
                overlay: 'drawer-overlay',
                open: 'drawer-open',
                close: 'drawer-close',
                dropdown: 'drawer-dropdown'
            }
        });
        $(".recherche-mobile").on("click",function(){
            drawerTop();
        });
        $(".close-btn-left").on("click",function(){
            $("#left").drawer("close");
        });
        $(".close-btn-top").on("click",function(){
            $("#top").drawer("close");
        });
    });
    function drawerTop(){
        $("#top").drawer("open");
    }

    if (jQuery('.contentList').data('domaine')) {
        jQuery('.navigation ul #' + jQuery('.contentList').data('domaine') + ' a').addClass('actif');
    }

    /*Placeholder pour ie9-*/
    jQuery('input, textarea').placeholder();

    /*Popup connexion espace abonné et mon compte*/

    jQuery('.btn_connect, .connexion-mobile').click(function() {
        if ($('.logout').length === 0) {
            jQuery.magnificPopup.open({
                items: {
                    type: 'inline',
                    src: '#abonnement'
                }
            });
            return false;
        }
    });
    jQuery('.deconnexion-mobile').click(function() {

    });
    jQuery('.partager').click(function(e){
        jQuery('.share.modal').toggle("slow");
        e.preventDefault();
    });

    /* magnificPopup */
    jQuery.extend(true, jQuery.magnificPopup.defaults, {
        tClose: 'Fermer (Esc)',
        tLoading: 'Chargement...',
        ajax: {
            tError: '<a href="%url%">Le contenu</a> ne peut être chargé.'
        }
    });

    jQuery('.page-popup').magnificPopup({
        type: 'ajax',
        callbacks: {
            updateStatus: function(data) {
                popupInception(data);
            }
        }
    });

    var imagePath = '/typo3conf/ext/atol_template/Resources/Public/Images/';
    jQuery('.troisclics').magnificPopup({
        items: [
            {src: imagePath + 'tuto1.png'},
            {src: imagePath + 'tuto2.png'},
            {src: imagePath + 'tuto3.png'},
        ],
        gallery: {
            enabled: true
        },
        type: 'image'
    });

    jQuery('.disable, #imageNoVideo, #overlayNoVideo, #showVideo').click(function() {
        jQuery.magnificPopup.open({
            items: {
                type: 'inline',
                src: '#abonnement'
            }
        });
        return false;
    });


    function popupInception(data) {
        if(data.status === "ready") {
            listJs();

            jQuery('.mfp-popup').on('click', '.page-popup', function(e) {
                e.stopImmediatePropagation();

                jQuery.magnificPopup.open({
                    items: {
                        src: jQuery(this).attr('href'),
                        type: 'ajax'
                    },
                    callbacks: {
                        updateStatus: function(data) {
                            popupInception(data);
                        }
                    }
                });

                e.preventDefault();
            });
        }
    }


    function listJs() {
        var filtreSearch = jQuery('#filtre-search');
        if(filtreSearch.length) {
            var options = {
                valueNames: filtreSearch.data('filter').split(' '),
                page: 15,
                plugins: [ListPagination({}), ListFuzzySearch()]
            };
            var userList = new List('filtre-search', options);
        }
    }


    /*Tooltip menu principal*/
    var navigation = jQuery('.navigation');
    navigation.tooltip({
        tooltipClass: "tooltip-styling"
    });

    /*************************/
    /******* Accueil *********/
    /*************************/

    /*Liste des séquences de une*/
    var accueilSequencesSlider = jQuery('#listSequencesMainAccueil ul').bxSlider({
        slideWidth: 750,
        auto: true,
        autoHover: true,
        controls:true,
        pause: 7000,
    });

    jQuery('body').on('click', '.volet .openclose', (function (e) {
        jQuery(this).closest('.volet').toggleClass('toggled');
    }));


    /*************************/
    /******* News *********/
    /*************************/

    // On affiche les 2 premières années des amphis-débats passés, puis sur un clic, on affiche l'année suivante
    jQuery('.previousAmphis h3').each(function( index ) {
        if (index === 0 || index === 1) {
            jQuery(this).nextUntil('h3').show();
            jQuery(this).show();
        };
    });
    jQuery('body').on('click', '.contentList .showmore.amphis', (function (e) {
        btnPlus.hide();
        loading.show();
        var nextHiddenYear = jQuery('.previousAmphis h3:hidden').first();
        if (nextHiddenYear) {
            btnPlus.show();
            loading.hide();
            nextHiddenYear.nextUntil('h3').show();
            nextHiddenYear.show();
        } else {
            jQuery('.showmore.amphis').hide();
        };
    }));


    /*************************/
    /******* AJAX *********/
    /*************************/

    // Pagination AJAX des tx_news
    ajaxPagination('.wrapperList .page-navigation li.last.next a', '.actusList', 1984);
    // et des contenu avec pagination FLUID
    ajaxPagination('.wrapperList .videos .pagination li.next a', '.videosList', 1985);
    ajaxPagination('.pagination.solr li.next a', '.four_thumb', 1987);
    ajaxPagination('.wrapperList .address .pagination li.next a', '.six_thumb', 1988);

    function ajaxPagination(paginationSelector, container, pageType) {
        var paginationUrl = jQuery(paginationSelector).attr('href');
        if (paginationUrl) {
            loadingDiv.show();
            jQuery('body').on('click', '.contentList .showmore', (function (e) {
                var currentPage = getPaginationNb(paginationUrl, pageType);
                if (currentPage === jQuery('.pagination li:not(.next)').length) {
                    loadingDiv.hide();
                } else {
                    btnPlus.hide();
                    loading.show();
                }
                e.preventDefault();
                var containerSelector = jQuery(container);
                jQuery.ajax({
                    type: 'POST',
                    url: paginationUrl + '&type=' + pageType,
                    data: jQuery(this).serializeArray(),
                    dataType: 'html',
                    success: function (data) {
                        loading.hide();
                        btnPlus.show();
                        jQueryrawData = jQuery(container, jQuery(data));
                        if (jQuery.trim(jQueryrawData.html())==='') {
                            btnPlus.hide();
                            loadingDiv.hide();
                        } else {
                            containerSelector.append(jQueryrawData.html());
                            currentPage = getPaginationNb(paginationUrl, pageType);
                            pageNumber = currentPage+1;
                            if (pageType === 1987) {
                                paginationUrl = removeUrlParameter(paginationUrl, 'tx_atolsolr_solr[@widget_0][currentPage]');
                                paginationUrl = removeUrlParameter(paginationUrl, 'cHash');
                                paginationUrl = paginationUrl + '&tx_atolsolr_solr%5B%40widget_0%5D%5BcurrentPage%5D=' + pageNumber;
                            } else {
                                paginationUrl = paginationSplitArray[0] + '=' + pageNumber;

                            }
                        }
                    },
                    error: function (xhr, thrownError) {
                        var msg = "<b>Une erreur est survenue lors de l\'affichage de la liste, merci de nous contacter</b><br>";
                        containerSelector.html(msg + xhr.status + ' ' + thrownError);
                    }
                });
            }));
        };
    }

    function getPaginationNb(paginationUrl, pageType) {
        if (pageType === 1987) {
            // exceptions pour solr : on doit se débarrasser du cHash, et le currentPage est à la fin de la requête
            paginationUrlPage = paginationUrl.split('cHash');
            paginationUrlBase = paginationUrl.split('currentPage');
            paginationUrlArr = (paginationUrlPage[0].split('&')).filter(Boolean);
            paginationUrlStr = paginationUrlArr[paginationUrlArr.length-1];
            return parseInt(getCurrentPage('tx_atolsolr_solr%5B%40widget_0%5D%5BcurrentPage%5D',paginationUrl))
        } else {
            paginationUrlStr = paginationUrl.split('&')[0];
        }
        paginationSplitArray = paginationUrlStr.split('=');

        return parseInt(paginationSplitArray[1])
    }

    function getCurrentPage(param,paginationUrl) {
        let vars = {};
        paginationUrl.replace(
            /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
            function( m, key, value ) { // callback
                vars[key] = value !== undefined ? value : '';
            }
        );

        if ( param ) {
            return vars[param] ? vars[param] : null;
        }

        return vars;
    }

    function removeUrlParameter(url, parameter) {
        let urlParts = url.split('?');

        if (urlParts.length >= 2) {
            // Get first part, and remove from array
            let urlBase = urlParts.shift();

            // Join it back up
            let queryString = urlParts.join('?');

            let prefix = encodeURIComponent(parameter) + '=';
            let parts = queryString.split(/[&;]/g);

            // Reverse iteration as may be destructive
            for (let i = parts.length; i-- > 0; ) {
                // Idiom for string.startsWith
                if (parts[i].lastIndexOf(prefix, 0) !== -1) {
                    parts.splice(i, 1);
                }
            }

            url = urlBase + '?' + parts.join('&');
        }
        return url;
    }

    /*************************/
    /********* Solr **********/
    /*************************/
    validateSearchInput('.megasearch');
    function validateSearchInput(selector) {
        jQuery('body').on('submit', selector + ' form', (function (e) {
            let validation = jQuery(selector + ' .validation');
            if (jQuery(selector + ' input[type=search]').val().length < 2) {
                e.preventDefault();
                validation.show();
            } else {
                validation.hide();
            }
        }));
    }

    jQuery('body').on('click', '.domaine-select', (function (e) {
        jQuery('.facet-list-value.domaine ul').toggleClass('opened');
    }));
    let selectedDomaine = jQuery('.facet-list-value.domaine .on');
    if (selectedDomaine.length) {
        let selectedDomaineTxt = selectedDomaine.text();
        selectedDomaine.html('Tous les domaines');
        jQuery('.domaine-select').toggleClass('changed');
        jQuery('.domaine-select span').html(selectedDomaineTxt);
        jQuery('.domaine-select .fleche-blanche').show();
        jQuery('.domaine-select .fleche-orange').hide();
    }

    /*************************************/
    /***********  IMPRESSION *************/
    /*************************************/

    jQuery(".print_video").click(function(){
        window.print();
    });


    /*************************************/
    /***********    VIDEOS 	 *************/
    /*************************************/
    jQuery('#menu-sequences .seq-control .seq-title').click(function() {
        if(typeof playerUodc !== 'undefined') {
            playerUodc.playSequence(jQuery(this).parent('.seq-control').data('num-sequence'));
            location.hash = 'detail-video';
        }
    });

    /* Onglets des catégories sous la vidéo */
    var ongletVideo = jQuery('#onglet-video');
    var firstActif = ongletVideo.find('ul.onglets li:not(.disable):not(.btn_Utils):first');
    firstActif.addClass("actif");
    jQuery(function() {
        ongletVideo.find('.info-video-content[data-info="' + firstActif.data('info') + '"]').fadeToggle();
    });

    ongletVideo.find('ul.onglets li:not(.disable):not(.btn_Utils)').click(function() {
        var info = jQuery(this).data('info');

        ongletVideo.find('li.actif').removeClass("actif");
        ongletVideo.find('li[data-info="' + info + '"]').addClass("actif");

        ongletVideo.find('.info-video-content:visible').fadeToggle(function() {
            ongletVideo.find('.info-video-content[data-info="' + info + '"]').fadeToggle();
        });
    });
    $('.carousel-home-card').slick({
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        infinite: false,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
            }

        }, {
            breakpoint: 800,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            }
        },  {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            }
        }]
    });
    let getUrlParameter = function getUrlParameter(sParam) {
        let sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]).replaceAll('+', ' ');
            }
        }
        return false;
    };
    if (getUrlParameter('tx_atolsolr_solr%5Bsw%5D') !== false) {
        $('input[name="tx_atolsolr_solr[sw]"]').val(getUrlParameter('tx_atolsolr_solr%5Bsw%5D'))
    }
});
